import classnames from 'classnames';
import React, { useCallback } from 'react';
import { MdCloudDownload as DownloadIcon } from 'react-icons/md';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

import { APP_MAP_ID } from '../../../constants';

const useStyles = createUseStyles({
  button: {
    borderRadius: 4,
    composes: [
      'p12',
      'my6',
      'fs14',
      'flex-columns',
      'flex-center',
      'items-center',
      'is-full-width',
    ],
    cursor: 'pointer',
    maxHeight: 46,
    transition: 'color 0.3s, background 0.3s',
  },
  label: {
    composes: ['mr12'],
  },
});

const ExportButtonComponent = React.memo(() => {
  const classes = useStyles();
  const done = useSelector(_ => _.done);

  const downloadTxtFile = useCallback(content => {
    const elt = document.createElement('a');
    const file = new Blob([content], {
      type: 'application/json;charset=utf-8',
    });
    elt.href = URL.createObjectURL(file);
    elt.download = `${APP_MAP_ID}.json`;
    document.body.appendChild(elt);
    elt.click();
  }, []);

  const exportHandler = useCallback(() => {
    const content = JSON.stringify(done);
    downloadTxtFile(content);
  }, [done, downloadTxtFile]);

  return (
    <button
      className={classnames(classes.button, 'smart-maps-button-gold')}
      type="button"
      onClick={exportHandler}>
      <span className={classes.label}>Exporter</span>
      <DownloadIcon size={22} />
    </button>
  );
});

ExportButtonComponent.displayName = 'ExportButtonComponent';

export default ExportButtonComponent;
